import React, { useState, useCallback, useRef } from 'react';
import Benefits from 'components/commercial/benefits';
import GetInTouch from 'components/commercial/get-in-touch';
import SearchOurProperties from 'components/commercial/search-our-properties';
import AutoplaySlides from 'components/autoplay-slides';
import { expCommercialTenant } from 'tenants/definitions/exp/commercial/us/exp-commercial-us.tenant';
import Quote from 'components/quote/quote';
import CommercialMetrics from 'components/commercial/metrics';
import InsightsCards from '../exp-components/insights-cards/InsightsCards';

import TiltedCards from 'components/tilted-cards';
import CommercialFaq from 'components/commercial/faq';
import CommercialHero from 'components/commercial/hero';
import HeadData from 'components/head-data';
import CtaButtons from 'components/commercial/cta-buttons';
import ExpCommercialLayout from 'components/layout/ExpCommercial';

import type { InsightCard } from '../exp-components/insights-cards/InsightsCards';

export type HomePageExpCommercialProps = {
  insightsCards?: InsightCard[];
};

export default function HomePageExpCommercial({ insightsCards = []}: HomePageExpCommercialProps) {
  const tenant = expCommercialTenant;
  const [showHeader, setShowHeader] = useState(true);
  const benefitsRef = useRef<HTMLDivElement>(null);
  const commercialBenefits = tenant.config.commercial.benefits;
  const quoteConfig = tenant.config.commercial.quotes.leo;
  const metrics = tenant.config.commercial.metrics;
  const tiltedCardsConfig = tenant.config.home.tiltedCards; // Our Services section

  const handleMinScale = useCallback(() => {
    setShowHeader(true);
  }, []);

  const handleEnter = useCallback(() => {
    setShowHeader(false);
  }, []);

  const handleLeave = useCallback(() => {
    setShowHeader(true);
  }, []);

  const author = {
    name: quoteConfig.authorName,
    title: quoteConfig.authorTitle,
    image: quoteConfig.authorImage,
    imageAlt: quoteConfig.authorImageAlt,
  };
  const quoteStyle = {
    highlightColor: quoteConfig.highlightColor,
  };

  return (
    <ExpCommercialLayout hideHeader={!showHeader}>
      <HeadData data={{ title: 'Homepage - eXp Commercial Brokerage' }} />
      <CommercialHero
        onMinScale={handleMinScale}
        onEnter={handleEnter}
        onLeave={handleLeave}
        videoSrc={tenant.config.home.heroVideo}
        scrollTargetRef={benefitsRef}
      />
      <Benefits elementRef={benefitsRef} cards={commercialBenefits.benefits} joinUsLink={commercialBenefits.joinUsLink} />
      <SearchOurProperties {...tenant.config.commercial.searchOurProperties} />
      <TiltedCards {...tiltedCardsConfig} />
      <AutoplaySlides {...tenant.config.home.autoplaySlides} />
      <InsightsCards cards={insightsCards} />
      <Quote author={author} content={quoteConfig.quoteContent} style={quoteStyle}>
        <CtaButtons />
      </Quote>
      <CommercialMetrics {...metrics} />
      <CommercialFaq 
        faqData={tenant.config.commercial.faq}
        disableHoverExpansion={true}
      />
      <GetInTouch {...tenant.config.commercial.getInTouch}/>
    </ExpCommercialLayout>
  );
}
